import styled from 'styled-components'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  StylesContainer: styled(Container)`
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    height: fit-content;
    position: relative;
  `,

  Title: styled.h1`
    font-size: 24px;
    line-height: 32px;
    color: ${COLORS.BLACK};
    font-weight: 700;
    text-align: center;
    width: fit-content;
    margin: 0 auto 32px;

    b {
      color: ${({ theme }) => theme.colors.strongTextColor};
      font-weight: 700;
    }
  `,

  PasswordWrapper: styled.div`
    position: relative;
    width: 100%;
    margin-bottom: 24px;
  `,

  PasswordToggle: styled.button`
    position: absolute;
    inset-inline-end: 16px;
    top: 28px;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #9ca3af;

    img {
      width: 24px;
    }
  `,

  Disclaimer: styled.p`
    font-size: 13px;
    line-height: 18px;
    color: #9ca3af;
    text-align: center;
    margin-bottom: 16px;

    a {
      color: #9ca3af;
      text-decoration: underline;
    }
  `,

  SubmitButton: styled(Button)`
    margin-top: 0;
  `,

  LoaderOverlay: styled.div`
    position: absolute;
    inset: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${COLORS.WHITE};
    border-radius: inherit;
  `,
} as const
